/*eslint-disable*/
/* eslint-disable react/prop-types */
/* eslint-disable quotes */
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Select from "react-select";

export default function CustomDropDownPicker({
  options,
  isMulti,
  onChange,
  value,
  setValue,
  placeholder,
  borderColor,
  required
}) {
  const customStyles = {
    input: (provided, state) => ({
      ...provided,
      height: "45px",
      margin: "0px",
      paddingBottom: "0px",
      paddingTop: "0px",
    }),
    control: (provided, state) => ({
      ...provided,
      borderColor: borderColor || "#ccc",
      borderWidth: 2,
      "&:hover": {
        borderColor: "grey"
      },
      boxShadow: state.isFocused ? "0 0 0 1px " : null,
      minHeight: "45px",
      paddingTop: "8px", // Add padding at the top for the floating label
    }),
    placeholder: (provided, state) => ({
      ...provided,
      position: "absolute",
      top: state.hasValue || state.isFocused ? "-8px" : "50%", // Position above the border
      left: required ? "12px" : "8px", // Adjust left position based on required indicator
      transform: state.hasValue || state.isFocused ? "translateY(0) scale(0.85)" : "translateY(-50%)",
      transition: "all 0.2s ease-out",
      backgroundColor: "white", // Always white background to overlap the border
      padding: "0 4px",
      color: (state.hasValue || state.isFocused) ? "#666" : "#999",
      fontSize: state.hasValue || state.isFocused ? "12px" : "inherit",
      lineHeight: 1,
      margin: 0,
      pointerEvents: "none",
      zIndex: 2, // Ensure it appears above the border
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      padding: "2px 8px", // Reduced padding
      paddingLeft: required ? "8px" : "4px",
      paddingRight: "4px",
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "white" : "black",
      backgroundColor: state.isSelected ? "red" : "white",
      "&:hover": {
        backgroundColor: state.isSelected ? "darkred" : "lightgray",
        color: state.isSelected ? "white" : "black"
      },
      padding: "8px 12px", // Normal option padding
      minHeight: "auto", // Remove minimum height
    }),
    menu: (provided, state) => ({
      ...provided,
      zIndex: 9999, // Ensure dropdown appears above other elements
      marginTop: "2px", // Reduce gap between input and dropdown
    }),
    menuList: (provided, state) => ({
      ...provided,
      padding: 0, // Remove extra padding in dropdown
      maxHeight: "200px", // Control max height
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "lightcoral",
      margin: "2px", // Reduced margin
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "black",
      padding: "2px 6px", // Reduced padding
      fontSize: "14px",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "black",
      "&:hover": {
        backgroundColor: "red",
        color: "white"
      }
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      padding: "0px 4px", // Reduced padding for indicators
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "4px", // Reduced padding
    }),
    clearIndicator: (provided) => ({
      ...provided,
      padding: "4px", // Reduced padding
    }),
  };

  // Find the selected option(s) based on the value
  const getSelectedOptions = () => {
    if (isMulti) {
      if (!value || !Array.isArray(value)) return [];
      return options.filter((option) => value.includes(option.value));
    } else {
      if (!value) return null;
      return options.find((option) => option.value === value);
    }
  };

  return (
    <div style={{ position: "relative" }}>
      {required && (
        <div
          style={{
            position: "absolute",
            left: "6px",
            top: "50%",
            transform: "translateY(-50%)",
            height: "60%",
            width: "3px",
            backgroundColor: "#ff0000",
            borderRadius: "1px",
            zIndex: 3,
          }}
        />
      )}
      <Select
        value={getSelectedOptions()}
        options={options}
        isMulti={isMulti}
        onChange={(selected) => {
          if (isMulti) {
            const selectedValues = selected
              ? selected.map((item) => item.value)
              : [];
            onChange(selectedValues);
            if (setValue) setValue(selectedValues);
          } else {
            const selectedValue = selected ? selected.value : null;
            onChange(selectedValue);
            if (setValue) setValue(selectedValue);
          }
        }}
        placeholder={placeholder}
        styles={customStyles}
      />
    </div>
  );
}